import React, { memo } from "react";
import BaseNode from "../BaseNode";
import { Titles } from "../Titles";

export default ({ id, data, selected, isConnectable }) => {
  return (
    <BaseNode
      id={id}
      data={data}
      valid={true}
      type={data.type}
      selected={selected}
      title={Titles.CustomerAverageTicket}
      isConnectable={isConnectable}
    ></BaseNode>
  );
};
